exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".js-accordion__item[data-v-5834e36a] {\n  position: relative;\n  overflow: hidden;\n  transition: padding-bottom 500ms;\n}\n.js-accordion__trigger[data-v-5834e36a] {\n  position: relative;\n  z-index: 10;\n}\n.js-accordion__content[data-v-5834e36a] {\n  position: absolute;\n  bottom: 0;\n}", ""]);

// exports
